module.exports = __webpack_public_path__ + "static/image/service/pc/taste.jpg?78a06787";